import * as React from 'react';

interface WorkOrderCheckAlertProps {
	title: string;
	subtitle: string;
	iconClassName: string;
}

/**
 * The severity-coloured heading shared by the confirmation modal and the inline block on the
 * invoice form: a filled ring carrying an exclamation, the verdict, and what to do about it.
 *
 * The ring is drawn rather than taken from antd's icon set because the design fills the circle
 * and reverses the glyph out of it, which `ExclamationCircleFilled` cannot express.
 */
export const WorkOrderCheckAlert: React.FC<WorkOrderCheckAlertProps> = ({
	title,
	subtitle,
	iconClassName,
}) => (
	<div className="flex flex-row items-start gap-x-s">
		<span
			className={`flex size-6 shrink-0 items-center justify-center rounded-full ${iconClassName}`}
		>
			<span className="text-[14px] font-bold leading-none text-white">!</span>
		</span>
		<div className="flex flex-1 flex-col gap-y-2xs">
			<div className="h5medium text-character-primary">{title}</div>
			<div className="bodyregular text-grey-8">{subtitle}</div>
		</div>
	</div>
);

export default WorkOrderCheckAlert;
